import { render, staticRenderFns } from "./StepFarmerCrops.vue?vue&type=template&id=b8d8fddc&scoped=true&"
import script from "./StepFarmerCrops.vue?vue&type=script&lang=js&"
export * from "./StepFarmerCrops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d8fddc",
  null
  
)

export default component.exports